<div
  class="info-panel-backdrop"
  [class.info-panel-backdrop--visible]="isOpen"
  (click)="onClose()"
  aria-hidden="true"
></div>

<aside
  class="info-panel"
  [class.info-panel--open]="isOpen"
  [attr.aria-hidden]="!isOpen || null"
  role="dialog"
  [attr.aria-label]="title"
>
  <mat-toolbar class="info-panel-toolbar">
    <span class="info-panel-title">{{ title }}</span>
    <button #closeBtn mat-icon-button (click)="onClose()" aria-label="Close panel" i18n-aria-label>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="info-panel-content">
    <mat-accordion [multi]="true">
      <ng-content />
    </mat-accordion>
  </div>
</aside>
